import { useState } from 'react';
import { useAuth } from '../stores/auth';
import { api } from '../api/client';
import { toast } from '../stores/toasts';
import { Modal } from './Modal';

export function WorkshopSwitcher() {
  const auth = useAuth();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!auth.workshops.length) return null;

  async function switchTo(workshopId: string) {
    setLoading(true);
    try {
      await api.switchWorkshop(workshopId);
      const w = auth.workshops.find((x) => x.id === workshopId);
      if (w) auth.setActiveWorkshop(w);
      toast.success(`Faol usta: ${w?.name ?? 'tanlandi'}`);
      setOpen(false);
    } catch (e: any) {
      toast.error(e?.message || 'Xatolik');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="workshop-switcher" onClick={() => setOpen(true)}>
        <div className={`workshop-pill ${auth.activeWorkshop ? 'active' : ''}`}>
          🏢 {auth.activeWorkshop?.name ?? 'Usta tanlang'} ▾
        </div>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title="Ustani tanlang">
        <div className="col">
          {auth.workshops.map((w) => (
            <button
              key={w.id}
              className={`card row-between ${auth.activeWorkshop?.id === w.id ? 'btn-primary' : ''}`}
              onClick={() => switchTo(w.id)}
              disabled={loading}
              style={{ textAlign: 'left', cursor: 'pointer' }}
            >
              <div>
                <div style={{ fontWeight: 600 }}>{w.name}</div>
                <div className="muted">{w.address ?? w.city ?? '—'}</div>
              </div>
              <div className="tag">{w.roleInWorkshop ?? '—'}</div>
            </button>
          ))}
        </div>
      </Modal>
    </>
  );
}
